import { render, staticRenderFns } from "./LayoutGray.vue?vue&type=template&id=d61af54a&scoped=true"
import script from "./LayoutGray.vue?vue&type=script&lang=js"
export * from "./LayoutGray.vue?vue&type=script&lang=js"
import style0 from "./LayoutGray.vue?vue&type=style&index=0&id=d61af54a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61af54a",
  null
  
)

export default component.exports